<template>
    <div>
        <el-carousel :height="computeHeight" :interval="2000" arrow="never">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>
        <div class="feature">
            <div class="flex">
                <div>
                    <img src="../../static/index/f1.png">
                    <div class="text">
                        <p><span class="counter-value"><count-to :startVal="0" :endVal="14" :formatter="formatter"
                                    :duration="3000"></count-to></span>年</p>
                        <span> 实体企业</span>
                    </div>
                </div>
                <div>
                    <img src="../../static/index/f2.png">
                    <div class="text">
                        <p><span class="counter-value"><count-to :startVal="0" :endVal="50" :formatter="formatter"
                                    :duration="3000"></count-to></span>+</p>
                        <span> 团队规模</span>
                    </div>
                </div>
                <div>
                    <img src="../../static/index/f3.png">
                    <div class="text">
                        <p><span class="counter-value"><count-to :startVal="0" :endVal="1000" :formatter="formatter"
                                    :duration="4000"></count-to></span>+</p>
                        <span> 服务客户</span>
                    </div>
                </div>
                <div>
                    <img src="../../static/index/f4.png">
                    <div class="text">
                        <p><span class="counter-value"><count-to :startVal="0" :endVal="1000" :formatter="formatter"
                                    :duration="4000"></count-to></span>+</p>
                        <span> 解决方案</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 产品与服务-->
        <div id="产品与服务" class="img-txt-shangxiacol" style="background-color:#f4f3f9">
            <div class="width" style="padding-top: 1px;">
                <div class="title">
                    <h2 style="margin-bottom:15px">丰富、安全、稳定、高性价比的产品和服务</h2>
                </div>
                <div class="conteiner-fluid">
                    <div class="row">
                        <div class="col" style="width:20%;text-align:center;">
                            <div class="imgscale">
                                <div class="img">
                                    <img decoding="async" src="../../static/index/app1.png">
                                </div>

                                <div class="text">
                                    <p style="border-bottom:1px solid #009aff">
                                        APP开发 </p>
                                    <span>
                                        Andriod/ios源生APP开发,跨平台混合APP开发,自主研发高性能框架。 </span>
                                </div>

                            </div>
                        </div>
                        <div class="col" style="width:20%;text-align:center;margin-top:55px">
                            <div class="imgscale">
                                <div class="img">
                                    <img decoding="async" src="../../static/index/app2.png">
                                </div>

                                <div class="text">
                                    <p style="border-bottom:1px solid #009aff">
                                        小程序开发 </p>
                                    <span>
                                        为电商、新零售、智能硬件等各行业提供一站式小程序定制开发。 </span>
                                </div>

                            </div>
                        </div>
                        <div class="col" style="width:20%;text-align:center;">
                            <div class="imgscale">
                                <div class="img">
                                    <img decoding="async" src="../../static/index/app3.png">
                                </div>

                                <div class="text">
                                    <p style="border-bottom:1px solid #009aff">
                                        网站系统开发 </p>
                                    <span>
                                        丰富的系统架构经验提供高并发、高可靠性、安全性系统解决方案。 </span>
                                </div>

                            </div>
                        </div>
                        <div class="col" style="width:20%;text-align:center;margin-top:55px">
                            <div class="imgscale">
                                <div class="img">
                                    <img decoding="async" src="../../static/index/app4.png">
                                </div>

                                <div class="text">
                                    <p style="border-bottom:1px solid #009aff">
                                        各行业软件开发 </p>
                                    <span>
                                        丰富的行业软件经验,包括物联网、智能硬件、电商、企业工具、智慧城市等。 </span>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div style="width: calc(100% - 100px);margin: 0px 50px;">
            <img src="../../static/index/f5.png" style="width: 100%;" />
        </div>

        <div class="leftcol-slideright">
            <div class="width">
                <div class="title">
                    <h2>
                        行业案例展示 </h2>
                    <span>多行业项目实战经验，将客户需求可视化呈现，向世界传播品牌声音</span>
                </div>
                <div class="conteiner-fluid">
                    <div class="row">
                        <div class="col-lg-2 nav-bar">
                            <div :class="{ 'nav-bar-on': activeIndex2 === '0' }" @click="handleClick('0')">
                                APP 定制开发 </div>
                            <div :class="{ 'nav-bar-on': activeIndex2 === '1' }" @click="handleClick('1')">
                                小程序定制开发 </div>
                            <div :class="{ 'nav-bar-on': activeIndex2 === '2' }" @click="handleClick('2')">
                                Web端开发 </div>
                            <div :class="{ 'nav-bar-on': activeIndex2 === '3' }" @click="handleClick('3')">
                                物联网开发 </div>
                        </div>
                        <div class="col-lg-10">
                            <div class="slidebody" :class="{ 'imgon': activeIndex2 === '0' }">
                                <div class="text">
                                    <div class="text-title">
                                        APP 定制开发 </div>
                                    <div class="line">
                                    </div>
                                    <div class="text-word">
                                        App定制开发，是指专注于手机应用软件开发与服务，通常专指手机上的应用软件，或称手机客户端。移动互联网时代是全民的移动互联网时代，是每个人的时代，也是每个企业的时代。APP便捷了每个人的生活，APP定制开发让每个企业都开始了移动信息化进程。
                                    </div>
                                </div>
                                <div class="lunbotu" @click="toProductWeb">
                                    <div
                                        class="swiper lunbotu-swiper-thumbs lunbotu-swiper-thumbs1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                                        <div class="swiper-slide swiper-slide-active"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="1 / 4">
                                            停车场管理平台</div>
                                        <div class="swiper-slide swiper-slide-next"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="2 / 4">
                                            销售管理平台</div>
                                        <div class="swiper-slide" style="width: 171px; margin-right: 20px;" role="group"
                                            aria-label="3 / 4">订单管理平台</div>
                                        <div class="swiper-slide" role="group" aria-label="4 / 4"
                                            style="width: 171px; margin-right: 20px;">线索管理平台</div>
                                    </div>
                                    <div style="margin-top: 20px;"
                                        class="swiper lunbotu-swiper-thumbs lunbotu-swiper-thumbs1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                                        <div v-for="(item, index) in anliApp" :key="index"
                                            class="swiper-slide swiper-slide-active"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="1 / 4">
                                            <img :src="item.url">
                                        </div>
                                    </div>
                                    <!-- <el-carousel style="margin-top: 20px;" :height="800" :interval="2000" arrow="never"
                                        indicator-position="none">
                                        <el-carousel-item v-for="(item, index) in anliApp" :key="index">
                                            <img :src="item.url">
                                        </el-carousel-item>
                                    </el-carousel> -->
                                </div>
                            </div>
                            <div class="slidebody" :class="{ 'imgon': activeIndex2 === '1' }">
                                <div class="text">
                                    <div class="text-title">
                                        小程序定制开发 </div>
                                    <div class="line">

                                    </div>
                                    <div class="text-word">
                                        微信小程序，简称小程序，是一种不用下载就能使用的应用。它实现了应用触手可及的梦想，用户扫一扫或搜一下即可打开应用。经过近几年的发展，已经构造了新的小程序开发环境和开发者生态。目前小程序日活用户达到两个亿，已经形成了一个新的互联网生态产业链。<br>
                                    </div>
                                </div>
                                <div class="lunbotu">
                                    <div
                                        class="swiper lunbotu-swiper-thumbs lunbotu-swiper-thumbs1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                                        <div class="swiper-slide swiper-slide-active"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="1 / 4">
                                            充电365</div>
                                        <div class="swiper-slide swiper-slide-next"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="2 / 4">
                                            云商城</div>
                                        <!-- <div class="swiper-slide" style="width: 171px; margin-right: 20px;" role="group"
                                            aria-label="3 / 4">上海银行</div>
                                        <div class="swiper-slide" role="group" aria-label="4 / 4"
                                            style="width: 171px; margin-right: 20px;">赛尔</div> -->
                                    </div>
                                    <div style="margin-top: 20px;"
                                        class="swiper lunbotu-swiper-thumbs lunbotu-swiper-thumbs1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                                        <div v-for="(item, index) in anliXcx" :key="index"
                                            class="swiper-slide swiper-slide-active"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="1 / 4">
                                            <img :src="item.url">
                                        </div>
                                    </div>
                                    <!-- <el-carousel style="margin-top: 20px;" :height="800" :interval="2000" arrow="never"
                                        indicator-position="none">
                                        <el-carousel-item v-for="(item, index) in sliders" :key="index">
                                            <img :src="item.img">
                                        </el-carousel-item>
                                    </el-carousel> -->
                                </div>
                            </div>
                            <div class="slidebody" :class="{ 'imgon': activeIndex2 === '2' }">
                                <div class="text">
                                    <div class="text-title">
                                        Web端开发 </div>
                                    <div class="line">

                                    </div>
                                    <div class="text-word">
                                        创建和维护网站和Web应用程序的过程。它包括使用不同的编程语言和技术来编写、测试和部署Web应用程序，以满足特定的业务需求和用户需求。 </div>
                                </div>
                                <div class="lunbotu">
                                    <div
                                        class="swiper lunbotu-swiper-thumbs lunbotu-swiper-thumbs1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                                        <div class="swiper-slide swiper-slide-active"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="1 / 4">
                                            丰田中国</div>
                                        <div class="swiper-slide swiper-slide-next"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="2 / 4">
                                            进口大众</div>
                                        <div class="swiper-slide" style="width: 171px; margin-right: 20px;" role="group"
                                            aria-label="3 / 4">中国移动</div>
                                        <div class="swiper-slide" role="group" aria-label="4 / 4"
                                            style="width: 171px; margin-right: 20px;">雷克萨斯</div>
                                    </div>
                                    <el-carousel style="margin-top: 20px;" :height="800" :interval="2000" arrow="never"
                                        indicator-position="none">
                                        <el-carousel-item v-for="(item, index) in anliWeb" :key="index">
                                            <img :src="item.url">
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>
                            </div>
                            <div class="slidebody" :class="{ 'imgon': activeIndex2 === '3' }">
                                <div class="text">
                                    <div class="text-title">
                                        物联网开发 </div>
                                    <div class="line">

                                    </div>
                                    <div class="text-word">
                                        基于专用装置和技术开发，通过网络接入，实现物与物、物与人的泛在连接，实现用户对产品和过程的智能化感知、识别和管理。 </div>

                                </div>
                                <div class="lunbotu">
                                    <div
                                        class="swiper lunbotu-swiper-thumbs lunbotu-swiper-thumbs1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                                        <div class="swiper-slide swiper-slide-active"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="1 / 4">
                                            智慧停车场</div>
                                        <div class="swiper-slide swiper-slide-next"
                                            style="width: 171px; margin-right: 20px;" role="group" aria-label="2 / 4">
                                            充电桩</div>
                                        <div class="swiper-slide" style="width: 171px; margin-right: 20px;" role="group"
                                            aria-label="3 / 4">物业监控大屏</div>
                                    </div>
                                    <el-carousel style="margin-top: 20px;" :height="800" :interval="2000" arrow="never"
                                        indicator-position="none">
                                        <el-carousel-item v-for="(item, index) in sliders" :key="index">
                                            <img :src="item.img">
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="youshi">
            <div class="width">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-lg-6">
                            <div class="title">
                                <span> 6 core advantages</span>
                                <h2>
                                    6大核心优势 </h2>
                            </div>
                            <div class="youshi-img">
                                <div v-for="(item, index) in youshi" :key="index"
                                    :class="{ 'youshi-img-on': activeIndex === index }">
                                    <img decoding="async" :src="item.url" alt="Image">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 youshi-neirong">
                            <div class="">
                                <div class="" @mouseover="showItem(0)" @mouseout="hideItem(0)">
                                    <p>
                                        专注行业 匠心13载 </p>
                                    <span>
                                        13年信息化行业坚守,见证行业一路成长 </span>
                                </div>
                                <div @mouseover="showItem(1)" @mouseout="hideItem(1)">
                                    <p>
                                        专业的开发团队 </p>
                                    <span>
                                        十余年技术沉淀,相关知识产权软著60余个 </span>
                                </div>
                                <div class="" @mouseover="showItem(2)" @mouseout="hideItem(2)">
                                    <p>
                                        丰富的行业经验 </p>
                                    <span>
                                        省内最早做汽车领域全流程覆盖解决方案的服务商 </span>
                                </div>
                                <div class="" @mouseover="showItem(3)" @mouseout="hideItem(3)">
                                    <p>
                                        客户隐私信息安全保护 </p>
                                    <span>
                                        严格实施信息安全等级保护，三级是底线 </span>
                                </div>
                                <div class="" @mouseover="showItem(4)" @mouseout="hideItem(4)">
                                    <p>
                                        全生命周期标准化服务 </p>
                                    <span>
                                        7*24小时在线服务,1分钟响应,5分钟给出解决方案,系统BUG问题终身免费解决 </span>
                                </div>
                                <div class="" @mouseover="showItem(5)" @mouseout="hideItem(5)">
                                    <p>
                                        项目风险管控 </p>
                                    <span>
                                        资深项目管理团队,全面评估把控风险,合同按期交付率100% </span>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- 合作伙伴-->
        <div id="合作伙伴" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                合作伙伴
            </div>
        </div>
        <div class="cooperation_parent">
            <div
                style="width: 100%; height: auto; margin: auto;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-evenly;align-items: center;">

                <img style="height: 160px;width: 160px;padding: 10px 40px;object-fit: contain"
                    v-for="(item, index) in hezuohuoban" :key="index" :src="item.url" />

                <!-- <img style="height: 160px;width: 160px;" src="../../static/other/toyota.png" />
                <img style="height: 160px;width: 160px;" src="../../static/other/vw.png" />
                <img style="height: 160px;width: 160px;object-fit: contain"
                    class="object-cover w-[110px] md:w-[132px] ml-0 h-auto"
                    src="https://oss-online.lexus.com.cn/static/images/black_logo.png?x-oss-process=image/format,webp/quality,Q_80">
                <img style="height: 160px;width: 160px;" src="../../static/other/nec2.png" />
                <img style="height: 160px;width: 160px;" src="../../static/other/bently.png" />
                <img style="height: 160px;width: 160px;" src="../../static/other/bmw.png" />
                <img style="height: 160px;width: 160px;" src="../../static/other/yutong.png" />
                <img style="height: 160px;width: 160px;" src="../../static/other/yingfeinidi.png" />
                <img style="height: 160px;width: 160px;" src="../../static/other/beijingqiche.png" />
                <img style="height: 160px;width: 160px;" src="../../static/other/xinyangjiaotong.png" />
                <img style="height: 160px;width: 160px;" src="../../static/other/luoyangjiaotong.png" /> -->
            </div>
        </div>
        <!-- 关于我们-->
        <div id="关于我们" class="about_me head-label" style="margin-top: 60px;">
            <div style="text-align: center;" class="font_size_24">
                公司简介
            </div>
        </div>
        <div
            style="width: 90%;background-color: #fafafa; margin: 10px auto;font-size: 14px;color: #181818;display: flex;">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12"
                    :style="{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: computeCompanyHeight }">
                    <!-- <div style="text-align: center;height: 200%;display: flex;align-items: center;justify-content: center;"> -->
                    <img style="width: 110%;" :src="leftImg" />
                    <!-- </div> -->
                </el-col>
                <el-col :xs="24" :sm="12">
                    <div style="text-indent: 2em;padding: 10px;">
                        <p>
                            2012年3月20日成立于郑州市高技术产业开发区软件孵化园区，这册资本1000万元。公司于2015年引进先进的技术与管理理念，转变公司发展策略，完善企业发展规划，引进战略合作伙伴，大规模提高技术研发投入，从战略的发展上提升到一个制高点，为企业发展起到决定性作用。
                        </p>
                        <p>
                            公司法人早起在郑州863软件园从事技术开发工作，05年在日电信息系统（中国）有限公司(NEC)从事互联网行业的技术研发，带领团队攻克多项技术难题。2012年凭着多年的工作经验以及对互联网的梦想开始走向创业之路，本着时代的需要，坚持走自主研发、改革创新的道路，与协作伙伴们实现了“协作共赢”的经营理念。对于公司员工坚持以“家”的文化进行管理，打造一个让员工满意、客户放心的高效研发团队,为客户提供高品质的解决方案和服务，携手实现数字化转型。
                        </p>
                        <p>
                            公司属于高新技术企业，有着10年软件开发行业相关经验的河南本地企业，且取得多项行业相关的软件著作权。始终坚持以自主研发为本；专业技术人员有55人，其中6～10年相关工作经验占25%，
                            3年以上相关工作经验的占75%，3年以下相关工作经验的占25%，有专业的研发、测试、实施和运维团队，始终秉承专业的人做专业的事。公司设立在国家中心城市、中原经济特区核心城市的河南省会郑州，充分利用郑州市地理、文化优势，将公司业务辐射全国。
                        </p>
                        <p>
                            公司着力于互联网前端技术，用创新核心技术为动力引领企业产品走向前沿；建设适应互联网高速发展的研发、销售、维护、定制为一体的综合性平台。提供全面细节的专业化服务，与伙伴共赢未来，为客户创造最大价值是公司永恒不变的追求。
                        </p>
                    </div>
                </el-col>
            </el-row>





            <!-- <div style="display: flex; flex-direction: column;width: 100%;">
                <p class="about_me_p">
                    2012年3月20日成立于郑州市高技术产业开发区软件孵化园区，注册资本1000万元。
                </p>
                <p class="about_me_p">
                    公司员工坚持以“家”的文化进行管理，打造一个让员工满意、客户放心的高效研发团队；
                </p>
                <p class="about_me_p">
                    致力于为客户提供高品质的IT解决方案和服务，携手实现数字化转型。
                </p>
                <p class="about_me_p">
                    技术团队稳定，经验丰富；技术与国内顶尖互联网公司看齐；
                </p>
                <p class="about_me_p">
                    项目管理上在瀑布和敏捷方面都有丰富经验，与世界五百强国际企业直接对接；
                </p>
                <p class="about_me_p">
                    有着10年以上软件研发及行业相关经验，且取得多项行业相关的软件著作权。
                </p>
                <p class="about_me_p">
                    有着10年以上软件研发及行业相关经验，且取得多项行业相关的软件著作权。
                </p>
            </div> -->
        </div>

        <!-- <div class="about_me head-label" style="margin: 30px 0px;">
            <div style="text-align: center;" class="font_size_24">
                公司地址
            </div>
        </div>

        <div style="width: 90%;margin: 10px auto;">
            <div style="display: flex; flex-direction: column;width: 100%;">
                <div class="map-body" :id="mapId"></div>
            </div>
        </div> -->


    </div>
</template>
<script>
import CountTo from 'vue-count-to'
export default {
    name: 'Index',
    components: {
        CountTo
    },
    data() {
        return {
            sliders: [],
            images: [
                // {
                //     img: require('../../static/other/用户管理.png'),
                //     title: "用户管理",
                //     content: ["用户消费分析", "用户标签设定"]
                // },
                // {
                //     img: require('../../static/other/店铺管理.png'),
                //     title: "店铺管理",
                //     content: ["店铺模板切换", "店铺商品上架"]
                // },
                // {
                //     img: require('../../static/other/数据分析.png'),
                //     title: "数据分析",
                //     content: ["交易量直观分析", "经营效果智能分析"]
                // }, {
                //     img: require('../../static/other/用户构建.png'),
                //     title: "用户互动",
                //     content: ["营销活动通知", "用户粘连度提升"]
                // },
                // {
                //     img: require('../../static/other/品牌渠道.png'),
                //     title: "品牌渠道",
                //     content: ["打造店铺自主品牌", "品牌多样化管理"]
                // }
            ],
            anliApp: [
                {
                    url: require('../../static/other/jutai.jpg'),
                },
                {
                    url: require('../../static/other/tingchechang3.jpg'),
                },
                {
                    url: require('../../static/other/jutai2.jpg'),
                },
                {
                    url: require('../../static/other/tingchechang.jpg'),
                },
            ],
            anliXcx: [
                {
                    url: require('../../static/other/chongdian.jpg'),
                },
                {
                    url: require('../../static/other/chongdian2.jpg'),
                },
                {
                    url: require('../../static/other/chongdian3.jpg'),
                }
            ],
            anliWeb: [
                {
                    url: require('../../static/other/jutaiyun.png'),
                },
                {
                    url: require('../../static/other/mysales.png'),
                },
                {
                    url: require('../../static/other/yaoxing.png'),
                }
            ],
            products: [
                {
                    img: [
                        {
                            url: require('../../static/other/tingchechang3.jpg'),
                        },
                        {
                            url: require('../../static/other/tingchechang2.jpg'),
                        },
                        {
                            url: require('../../static/other/tingchechang.jpg'),
                        },
                    ],
                    title: "聚泰云停车场管理平台",
                    content: [
                        "提高企业运营效率和降低成本",
                        "通过信息化、智能化的方式对企业仓库进行全面管理",
                        "实时保存人员操作车辆记录，可有效规避车辆运损纠纷",
                    ]
                },
                {
                    img: [
                        {
                            url: require('../../static/other/tingchechang.jpg'),
                        },
                        {
                            url: require('../../static/other/tingchechang2.jpg'),
                        },
                        {
                            url: require('../../static/other/jutai2.jpg'),
                        }
                    ],
                    title: "聚泰云销售管理平台",
                    content: [
                        "建立完整客户档案",
                        "多渠道开发销售线索",
                        "实时跟踪订单交付进度",
                        "跟踪线索转化情况，进行统一的管理和运营",
                        "销售过程全程可视化管理，加速销售转化，提升协同效率",
                    ]
                },
                {
                    img: [
                        {
                            url: require('../../static/other/chongdian.jpg'),
                        },
                        {
                            url: require('../../static/other/chongdian2.jpg'),
                        },
                        {
                            url: require('../../static/other/chongdian3.jpg'),
                        }
                    ],
                    title: "聚泰云365充电平台",
                    content: [
                        "用户可以随时查询附近的共享充电桩位置",
                        "扫码充电、线上支付，提高充电的便捷性",
                        "减少对传统能源的依赖，降低碳排放，实现可持续发展",
                        "可实现资源的优化配置，提高充电设施的利用率，降低运营成本",
                    ]
                }
            ],
            activeIndex: 0,
            activeIndex2: '0',
            manages: [
                {
                    // img: [require('../../static/other/product_info.jpg')],
                    title: "小程序+公众号一体化微信商城管理平台",
                    content: ["公众号菜单自定义发布 微信图文图片素材管理", "商品多规格SKU自定义上架 分类自定义设置",
                        "用户管理 用户自定义标签，了解用户消费行为",
                        "订单管理 实时掌握商品交易详情", "物流闪电发货 实时掌握物流追踪状态",
                    ]
                }
            ],
            spec: {
                img: require('../../static/other/arrow.png'),
                product: [
                    {
                        img: require('../../static/other/fanganzixun.png'),
                        title: "方案咨询",
                        contents: ["为客户提供信息化、数字化、一体化的业务运营管理平台的解决方案，并进行定制化的服务"]
                    },
                    {
                        img: require('../../static/other/xitongyanfa.png'),
                        title: "系统研发&集成",
                        contents: ["信息化软硬件项目和系统集成类项目的合作研发，自主研发；客户定制化开发等项目合作"]
                    },
                    {
                        img: require('../../static/other/shishipeixun.png'),
                        title: "实施培训",
                        contents: ["为产品的顺利上线部署保驾护航，依据实际业务需求为客户提供高品质的实施方案及计划"]
                    },
                    {
                        img: require('../../static/other/xitongyunwei.png'),
                        title: "运维服务",
                        contents: ["为后期业务展开提供技术保障，为客户提供产品版本的迭代升级，与客户保持良性的合作关系，互惠互利。"]
                    },
                    {
                        img: require('../../static/other/disanfangceshi.png'),
                        title: "第三方测试",
                        contents: ["为产品的质量保驾护航，对产品进行多层次、多视角、多平台等完整的实体业务测试，来保证产品交付质量。"]
                    },
                    {
                        img: require('../../static/other/itjianli.png'),
                        title: "IT监理",
                        contents: ["专业的IT监理团队，为各企业进行IT方面的监理工作，保证产品的品质和工作效率。"]
                    }
                ]
            },
            company: [
                "企业从事于：专注于中小企业信息化产品开发及解决方案服务",
                "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
                "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
                "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
            ],
            youshi: [
                {
                    url: require('../../static/index/fenxi.jpg'),
                },
                {
                    url: require('../../static/index/xuqiu.png'),
                },
                {
                    url: require('../../static/index/kaifa.jpg'),
                },
                {
                    url: require('../../static/index/goutong.jpg'),
                },
                {
                    url: require('../../static/index/qc.jpg'),
                },
                {
                    url: require('../../static/index/fanying.jpg'),
                },
            ],
            hezuohuoban: [
                {
                    url: require('../../static/other/xinyangjiaotong.png'),
                },
                {
                    url: require('../../static/other/lexus.png'),
                },
                {
                    url: require('../../static/other/beijingqiche.png'),
                },
                {
                    url: require('../../static/other/pingdingshanjiaotong.png'),
                },
                {
                    url: require('../../static/other/luoyangjiaotong.png'),
                },
                {
                    url: require('../../static/other/nec.png'),
                },
                {
                    url: require('../../static/other/yutong.png'),
                },
                {
                    url: require('../../static/other/vw.png'),
                },
                {
                    url: require('../../static/other/bently.png'),
                },
                {
                    url: require('../../static/other/toyota.png'),
                },
                {
                    url: require('../../static/other/bmw.png'),
                },
            ],
            leftImg: require('../../static/other/logo.jpg'),
            map: "",
            mapId: "", //我这里采用了动态id这个不是必须的，看自己需求来
        }
    },
    methods: {
        createMap(lgt, lat) {
            // this.maploading=true;
            // eslint-disable-next-line no-undef
            this.map = new BMapGL.Map(this.mapId, { enableMapClick: false }) // 创建Map实例,GL版命名空间为BMapGL(鼠标右键控制倾斜角度)
            // eslint-disable-next-line no-undef
            this.map.centerAndZoom(new BMapGL.Point(lgt, lat), 16)      // 初始化地图,设置中心点坐标和地图级别
            // 创建点标记
            // eslint-disable-next-line no-undef
            const point = new BMap.Point(113.57221, 34.81937);
            // eslint-disable-next-line no-undef
            var marker1 = new BMapGL.Marker(point);
            this.map.addOverlay(marker1);
            var opts = {
                width: 300, // 信息窗口宽度
                height: 90, // 信息窗口高度
                title: "郑州聚泰科技有限公司", // 信息窗口标题
            };
            // eslint-disable-next-line no-undef
            var infoWindow = new BMapGL.InfoWindow(
                `<p style="font-size:12px">郑州市高新技术开发区瑞达路96号创业中心2号楼B627</p>`,
                opts
            ); // 创建信息窗口对象

            // map.openInfoWindow(infoWindow, point); //打开信息窗口
            this.map.openInfoWindow(infoWindow, point);
            //监听事件
            var that = this
            this.map.addEventListener("click", function () {
                that.map.openInfoWindow(infoWindow, point);
            });
        },
        showItem(index) {
            this.activeIndex = index;
        },
        hideItem(index) {
            if (this.activeIndex === index) {
                this.activeIndex = 0;
            }
        },
        handleClick(index) {
            this.activeIndex2 = index;
        },
        formatter(value) {
            // 直接返回数值，不进行任何格式化
            return value;
        },
        toProductWeb() {
            window.open('http://product.jutaiyun.cn','_black')
        },
    },
    created() {
        this.mapId = 'map' + new Date().getTime();
        // eslint-disable-next-line no-undef
        const point = new BMapGL.Point(113.57221, 34.81937);
        //创建地图
        this.$nextTick(() => {
            this.createMap(point.lng, point.lat);
        })
    },
    mounted() {
        this.sliders = [
            {
                img: require("../../static/index/1.jpg")
            },
            {
                img: require("../../static/index/2.jpg")
            },
            {
                img: require("../../static/index/3.jpg")
            },
        ]
    },
    computed: {
        //计算高度
        computeHeight() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                return '550px';
            } else {
                return '250px';
            }
        },
        //计算高度
        computeCompanyHeight() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                return '100%';
            } else {
                return '200px';
            }
        },
        computeArrowImg() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 450) {
                return require('../../static/other/arrow.png');
            } else {
                return require('../../static/other/arrow_down.png');
            }
        }

    },
}
</script>

<style scoped>
.border_parent {
    width: 90%;
    margin: auto;
}

.slider_img {
    width: 100%;
    height: 600px;
    object-fit: contain
}

.solve {
    margin-top: 30px;
    margin-bottom: 10px
}

.border {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    height: auto;
    margin: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.border_one {
    margin-left: 0;
}

.border_img_parent {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.product_mobile_content {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.product_mobile_img {
    width: 50%;
}

.product_mobile_title {
    font-weight: bold;
    text-align: center;
}

.product_pc_one {
    text-align: center;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.font_size_30 {
    font-size: 1.875em;
}

.product_font_style {
    font-size: 1.125em;
}

.product_pc_img {
    width: 100%
}

.product_pc_img_div {
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
}

.product_pc {
    display: flex;
    width: 90%;
    margin: 20px auto;
    background: #F2F6FC;
    align-items: center;
}

.product_spec_title {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 10px
}

.product_spec_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    justify-content: space-evenly;
    align-items: center;
    height: auto
}

.cooperation_parent {
    display: flex;
    justify-content: center;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.border_spec {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    background-image: url('../../static/production/1.jpg');
    background-size: cover;
    width: 15%;
    height: 400px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
}

.border_spec1 {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    background-image: url('../../static/production/2.jpg');
    background-size: cover;
    width: 15%;
    height: 400px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
}

.border_spec2 {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    background-image: url('../../static/production/3.jpg');
    background-size: cover;
    width: 15%;
    height: 400px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
}

.border_spec3 {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    background-image: url('../../static/production/4.jpg');
    background-size: cover;
    width: 15%;
    height: 400px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
}

.border_spec4 {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    background-image: url('../../static/production/5.jpg');
    background-size: cover;
    width: 15%;
    height: 400px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
}

.border_spec5 {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    background-image: url('../../static/production/6.jpg');
    background-size: cover;
    width: 15%;
    height: 400px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
}

.about_me_p {
    font-size: 1.25em;
    font-weight: normal;
    padding: 0 20px;
    margin: 10px;
}

.border_title {
    font-family: "PingFang SC";
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
}

.border_content_one {
    /* margin-top: 20px; */
    font-size: 1.125em;
    text-align: center;
}

.border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 25px;
    text-align: center;
}

.img_border {
    margin-top: 15px;
    width: 80px;
    height: 80px
}

.border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}

.border_spec_content {
    font-size: 0.8rem;
    padding: 10px;
    text-align: center;
    color: #fff;
}

.border_spec_content_one {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    text-align: center;
}

.border_spec_inner_last {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 25px;
    text-align: center;
}

.cooperation {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    margin-top: 30px;
    width: 100%;
}

.about_me {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    width: 100%;
}

.product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    background: #FAFAFA;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.product_mobile_img_div {
    width: 50%;
    height: auto;
}

.product_mobile_content_one {
    margin-top: 20px;
    /* text-align: center; */
}

.product_mobile_content_two {
    margin-top: 10px;
    text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
    .slider_img {
        height: 250px;
        width: 100%;
    }


    .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto;
        flex-direction: column;
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 100%;
        height: auto;
        margin: 10px 0 auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
    }

    .border_img_parent {
        margin-top: 0;

    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        height: auto;
        background: #F2F6FC;
    }

    .product_mobile_content {
        width: 100%;
        margin-top: 15px;
    }

    .product_mobile_content_one {
        margin-top: 5px;
    }

    .product_mobile_content_two {
        margin-top: 5px;
    }

    .product_mobile_img_div {
        display: flex;
        width: 100%;
        height: auto;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .product_mobile_img {
        float: left;
    }

    .product_mobile_title {
        font-weight: bold;
    }

    .product_pc_one {
        width: 100%;
        margin-top: 15px;
    }

    .font_size_30 {
        font-size: 1.25em;
    }

    .product_font_style {
        font-size: 1em;
    }

    .product_pc_img {
        height: 280px;
        width: 320px;
    }

    .product_pc_img_div {
        width: 100%;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
    }

    .product_pc {
        display: flex;
        width: 90%;
        height: auto;
        margin: 20px auto;
        background: #F2F6FC;
        flex-direction: column;
    }

    .head-label {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        display: flex;
        margin-top: 10px;
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
        height: auto;
        flex-direction: column;
    }

    .border_spec {
        float: left;
        height: auto;
        margin: 8px;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }


    .border_title {
        font-family: "PingFang SC";
        margin-top: 5px;
        font-size: 1.125em;
        font-weight: bold;
    }

    .border_content_one {
        margin-top: 5px;
        font-size: 1.125em;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 8px;
    }

    .img_border {
        margin-top: 8px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        /*background-color: aqua;*/
        /* height: 90px; */
    }

    .border_spec_content_one {
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
    }

    .border_spec_inner_last {
        /*background-color: bisque;*/
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 8px;
    }

    .about_me {
        display: flex;
        margin-top: 10px;
        width: 100%;
    }
}

.border_spec_img {
    width: 55px;
    height: 45px;
    align-self: center
}

.font_size_24 {
    font-size: 1.5em;
}

.font_size_12 {
    font-size: 1.2em;
    color: #fff;
    font-weight: bold;
}

.map-body {
    position: relative;
    /* width: 500px; */
    height: 500px;
    border: 1px solid #dcdfe6;
}

.feature {
    width: calc(100% - 100px);
    margin: 0px 50px 0 50px;
    box-sizing: border-box;
    /* position: absolute;
    top: 530px; */
    /* z-index: 1222; */
}

.feature .flex {
    display: flex;
    background-color: white;
    padding: 20px 70px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.feature .flex>div {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
}

.feature .flex>div .text {
    margin-left: 20px;
}

.feature .flex>div .text p {
    margin: 0;
    font-size: 28px;
    font-weight: 600;
    line-height: 1;
}

.row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}

.img-txt-shangxiacol {
    padding-bottom: 60px;
    overflow: hidden;
}

.img-txt-shangxiacol .col {
    flex-basis: unset;
    margin-bottom: 20px;
}

.img-txt-shangxiacol .title {
    margin: 60px 0 60px 0;
    text-align: center;
}

.img-txt-shangxiacol .title h2 {
    margin: 0;
    font-size: 32px;
}

.img-txt-shangxiacol .col .imgscale .img {
    height: 296px;
    width: 100%;
    overflow: hidden;
}

.img-txt-shangxiacol .col .imgscale .text {
    background-color: white;
}

.img-txt-shangxiacol .col .imgscale {
    height: unset;
}

.img-txt-shangxiacol .col>div {
    border-radius: 20px;
    overflow: hidden;
}

.img-txt-shangxiacol .col>div .text {
    padding: 0 20px 20px 20px;
    overflow: hidden;
    transition: all 0.5s;
    position: relative;
    z-index: 2;
}

.img-txt-shangxiacol .col .imgscale img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
    transition: all 0.5s;
    position: relative;
    z-index: 1;
    object-fit: cover;
}

.col {
    -ms-flex-preferred-size: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
    padding-right: 15px;
    padding-left: 15px;
}

.img-txt-shangxiacol .col .imgscale {
    height: unset;
}

.img-txt-shangxiacol .col>div p {
    font-size: 24px;
    padding-bottom: 20px;
}

.img-txt-shangxiacol .col .imgscale:hover img {
    transform: scale(1.1)
}

.img-txt-shangxiacol .col .imgscale:hover .text {
    background-color: #009aff;
    color: white
}

.col-lg-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 48%;
    padding-right: 15px;
    padding-left: 15px;
    width: 100%;
}

.youshi .title span {
    font-size: 18px;
    color: #bababa;
    text-transform: uppercase;
}

.youshi .title h2 {
    margin: 0;
    font-size: 32px;
}

.youshi .youshi-neirong>div>div {
    padding: 10px 45px;
    margin-top: 20px;
}

.youshi .youshi-neirong>div>div:hover {
    background-image: linear-gradient(to right, #029aff, #52a2ed, #9fbcea, #f3f7fc);
    color: white
}

.youshi .youshi-neirong>div>div p {
    font-size: 22px;
    margin: 0;
    margin: 0;
    margin-bottom: 10px;
}

.youshi .youshi-neirong>div>div span {
    font-size: 14px
}

.youshi .youshi-neirong>div .nron {
    background-image: linear-gradient(to right, #029aff, #52a2ed, #9fbcea, #f3f7fc);
    color: white
}

.youshi {
    overflow: hidden;
    margin-bottom: 30px
}

.youshi img {
    width: 100%;
    height: auto;
    padding-right: 15px;
    padding-left: 15px;
}

.youshi .youshi-img>div {
    display: none
}

.youshi .youshi-img-on {
    display: block !important
}

.youshi .title {
    margin-bottom: 20px;
    padding-right: 15px;
    padding-left: 15px;
}

.youshi .title h2 {
    margin: 0;
    font-size: 32px
}

.youshi .title span {
    font-size: 18px;
    color: #bababa;
    text-transform: uppercase
}

.youshi .youshi-neirong>div {
    border-left: 1px solid #009aff;
    height: 100%
}

.youshi .youshi-neirong>div>div {
    padding: 10px 45px;
    margin-top: 20px
}

.swiper-container {
    width: 100%;
    height: 300px;
    /* 设置轮播图的高度 */
    position: relative;
}

.swiper-wrapper {
    height: 100%;
}

.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.swiper-button-prev,
.swiper-button-next {
    color: #fff;
    /* 导航按钮的颜色 */
}

.swiper-pagination {
    bottom: 10px;
    /* 分页器的位置 */
}


.leftcol-slideright {
    color: white;
    overflow: hidden;
    padding-bottom: 60px;
    background: url('../../static/index/beijing.jpg') center no-repeat
}

.leftcol-slideright .title {
    margin: 60px 0 80px 0;
    text-align: center
}

.leftcol-slideright .title h2 {
    margin: 0 0 20px 0;
    font-size: 32px
}

.leftcol-slideright .title span {
    font-size: 24px
}

.leftcol-slideright .text {
    width: 40%;
    display: inline-block;
    vertical-align: top;
    padding: 0 80px 0 40px;
    box-sizing: border-box;
}

.leftcol-slideright .text .text-title {
    font-size: 24px;
    font-weight: bold
}

.leftcol-slideright .text .line {
    height: 10px;
    width: 100px;
    background-image: linear-gradient(to right, #fbfdfe, #79a5e0, #052c4d);
    margin: 15px 0 45px 0
}

.leftcol-slideright .text .text-word {
    font-size: 16px;
    line-height: 28px
}

.leftcol-slideright .col-lg-10 {
    position: relative
}

.leftcol-slideright .text .text-btn {
    padding: 10px 25px;
    background-color: #009aff;
    color: white;
    font-size: 14px;
    border-radius: 6px;
    display: inline-block;
    position: absolute;
    bottom: 0px
}

.leftcol-slideright .text .text-btn:hover {
    background-color: #1277b9 !important
}

.leftcol-slideright .lunbotu {
    width: 59%;
    display: inline-block;
    vertical-align: top
}

.leftcol-slideright .lunbotu img {
    width: 100%;
    height: 100%;
    border-radius: 6px
}

.leftcol-slideright .slidebody {
    display: none
}

.leftcol-slideright .imgon {
    display: block
}

.leftcol-slideright .nav-bar {
    border-right: 1px solid white;
    font-size: 16px;
    padding-right: 0
}

.leftcol-slideright .nav-bar>div {
    line-height: 45px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 10px
}

.leftcol-slideright .nav-bar>div:hover {
    background-image: linear-gradient(to right, #0069ca, #79a5e0, #6cceff);
}

.leftcol-slideright .nav-bar .nav-bar-on {
    background-image: linear-gradient(to right, #0069ca, #79a5e0, #6cceff);
}

.col-lg-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
}

.col-lg-10 {
    -ms-flex: 0 0 82.333333%;
    flex: 0 0 82.333333%;
    max-width: 82.333333%;
}

.lunbotu-swiper-thumbs .swiper-slide {
    background-color: white;
    font-size: 18px;
    text-align: center;
    border-radius: 6px;
    line-height: 45px;
    color: #052c4d;
    cursor: pointer;
    user-select: none;
}

.lunbotu-swiper-thumbs {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
}
</style>